export const SLACK_HAS_SEEN_NEW = 'Integrations:slack:email:hasSeenNew';
export const HAS_SEEN_RELIABLE_OPEN_ONBOARDING = 'hasSeenReliableOpenOnboarding';
export const HAS_SEEN_APPROVALS_ONBOARDING = 'hasSeenApprovalsOnboarding';
export const HAS_SEEN_EMAIL_INSIGHTS = 'hasSeenAiInsightsPanel';